const LIST_CYLINDER_VEHICLE = [
  {
    key: '',
    value: '',
    label: 'Silinder',
    parent: '',
  },
  {
    key: '1709',
    value: '1.8',
    label: '1.8',
    parent: '1704',
  },
  {
    key: '1710',
    value: '2.0',
    label: '2.0',
    parent: '1704',
  },
  {
    key: '1713',
    value: '1.6',
    label: '1.6',
    parent: '1701',
  },
  {
    key: '1714',
    value: '1.8',
    label: '1.8',
    parent: '1701',
  },
  {
    key: '1715',
    value: '2.0',
    label: '2.0',
    parent: '1701',
  },
  {
    key: '1716',
    value: '2.4',
    label: '2.4',
    parent: '1701',
  },
  {
    key: '1717',
    value: '2.6',
    label: '2.6',
    parent: '1701',
  },
  {
    key: '1721',
    value: '3.0',
    label: '3.0',
    parent: '1701',
  },
  {
    key: '1718',
    value: '2.4',
    label: '2.4',
    parent: '1702',
  },
  {
    key: '1719',
    value: '2.6',
    label: '2.6',
    parent: '1702',
  },
  {
    key: '1720',
    value: '2.8',
    label: '2.8',
    parent: '1702',
  },
  {
    key: '1731',
    value: '3.0',
    label: '3.0',
    parent: '1702',
  },
  {
    key: '1733',
    value: '3.0',
    label: '3.0',
    parent: '1706',
  },
  {
    key: '3074',
    value: '2.8',
    label: '2.8',
    parent: '1707',
  },
  {
    key: '1734',
    value: '3.0',
    label: '3.0',
    parent: '1707',
  },
  {
    key: '1738',
    value: '2.7',
    label: '2.7',
    parent: '1705',
  },
  {
    key: '1739',
    value: '4.2',
    label: '4.2',
    parent: '1708',
  },
  {
    key: '1740',
    value: '1.8',
    label: '1.8',
    parent: '1703',
  },
  {
    key: '1741',
    value: '2.0',
    label: '2.0',
    parent: '1703',
  },
  {
    key: '1753',
    value: '2.6',
    label: '2.6',
    parent: '1752',
  },
  {
    key: '1754',
    value: '1.5',
    label: '1.5',
    parent: '1750',
  },
  {
    key: '1755',
    value: '1.6',
    label: '1.6',
    parent: '1751',
  },
  {
    key: null,
    value: null,
    label: null,
    parent: '1787',
  },
  {
    key: '1943',
    value: '2.0',
    label: '2.0',
    parent: '1786',
  },
  {
    key: '2606',
    value: '1.9',
    label: '1.9',
    parent: '1759',
  },
  {
    key: '2008',
    value: '2.0',
    label: '2.0',
    parent: '1759',
  },
  {
    key: '1950',
    value: '2.0',
    label: '2.0',
    parent: '1760',
  },
  {
    key: '2413',
    value: '2.5',
    label: '2.5',
    parent: '1761',
  },
  {
    key: '3093',
    value: '2.0',
    label: '2.0',
    parent: '1762',
  },
  {
    key: '2295',
    value: '2.0',
    label: '2.0',
    parent: '1770',
  },
  {
    key: '2577',
    value: '2.5',
    label: '2.5',
    parent: '1771',
  },
  {
    key: '2487',
    value: '2.0',
    label: '2.0',
    parent: '1773',
  },
  {
    key: '2432',
    value: '2.8',
    label: '2.8',
    parent: '1773',
  },
  {
    key: '2610',
    value: '3.0',
    label: '3.0',
    parent: '1774',
  },
  {
    key: '2372',
    value: '1.5',
    label: '1.5',
    parent: '2371',
  },
  {
    key: '2374',
    value: '2.0',
    label: '2.0',
    parent: '2371',
  },
  {
    key: '2572',
    value: '2.0',
    label: '2.0',
    parent: '1785',
  },
  {
    key: '2625',
    value: '2.5',
    label: '2.5',
    parent: '1785',
  },
  {
    key: '2908',
    value: '3.0',
    label: '3.0',
    parent: '1785',
  },
  {
    key: '2664',
    value: '2.0',
    label: '2.0',
    parent: '2659',
  },
  {
    key: '2324',
    value: '3.0',
    label: '3.0',
    parent: '1784',
  },
  {
    key: '2859',
    value: '3.0',
    label: '3.0',
    parent: '1788',
  },
  {
    key: '1665',
    value: '0.8',
    label: '0.8',
    parent: '1637',
  },
  {
    key: '1666',
    value: '1.1',
    label: '1.1',
    parent: '1637',
  },
  {
    key: '1667',
    value: '2.0',
    label: '2.0',
    parent: '1638',
  },
  {
    key: '2965',
    value: '1.4',
    label: '1.4',
    parent: '1639',
  },
  {
    key: '1668',
    value: '1.5',
    label: '1.5',
    parent: '1639',
  },
  {
    key: '2331',
    value: '2.2',
    label: '2.2',
    parent: '2330',
  },
  {
    key: '1669',
    value: '2.0',
    label: '2.0',
    parent: '1640',
  },
  {
    key: '1670',
    value: '2.4',
    label: '2.4',
    parent: '1640',
  },
  {
    key: '1672',
    value: '1.2',
    label: '1.2',
    parent: '1641',
  },
  {
    key: '1671',
    value: '2.5',
    label: '2.5',
    parent: '1641',
  },
  {
    key: '2623',
    value: '1.6',
    label: '1.6',
    parent: '2622',
  },
  {
    key: '2319',
    value: '1.4',
    label: '1.4',
    parent: '2318',
  },
  {
    key: '2182',
    value: '1.8',
    label: '1.8',
    parent: '2181',
  },
  {
    key: '1674',
    value: '1.2',
    label: '1.2',
    parent: '1642',
  },
  {
    key: '2473',
    value: '1.2',
    label: '1.2',
    parent: '1643',
  },
  {
    key: '2477',
    value: '1.3',
    label: '1.3',
    parent: '1643',
  },
  {
    key: '1673',
    value: '1.5',
    label: '1.5',
    parent: '1643',
  },
  {
    key: '1866',
    value: '2.2',
    label: '2.2',
    parent: '1865',
  },
  {
    key: '3057',
    value: '1.4',
    label: '1.4',
    parent: '3056',
  },
  {
    key: '2120',
    value: '1.8',
    label: '1.8',
    parent: '2119',
  },
  {
    key: '304',
    value: '1.0',
    label: '1.0',
    parent: '24',
  },
  {
    key: '2620',
    value: '1.2',
    label: '1.2',
    parent: '24',
  },
  {
    key: '368',
    value: '0.85',
    label: '0.85',
    parent: '357',
  },
  {
    key: '369',
    value: '1.3',
    label: '1.3',
    parent: '359',
  },
  {
    key: '370',
    value: '1.3',
    label: '1.3',
    parent: '360',
  },
  {
    key: '371',
    value: '1.6',
    label: '1.6',
    parent: '360',
  },
  {
    key: '2108',
    value: '1.5',
    label: '1.5',
    parent: '361',
  },
  {
    key: '372',
    value: '1.6',
    label: '1.6',
    parent: '361',
  },
  {
    key: '315',
    value: '1.3',
    label: '1.3',
    parent: '314',
  },
  {
    key: '316',
    value: '1.5',
    label: '1.5',
    parent: '314',
  },
  {
    key: '373',
    value: '1.6',
    label: '1.6',
    parent: '362',
  },
  {
    key: '1463',
    value: '1.0',
    label: '1.0',
    parent: '1462',
  },
  {
    key: '1464',
    value: '1.3',
    label: '1.3',
    parent: '1462',
  },
  {
    key: '1465',
    value: '1.5',
    label: '1.5',
    parent: '1462',
  },
  {
    key: '1862',
    value: '1.3',
    label: '1.3',
    parent: '1861',
  },
  {
    key: '2241',
    value: '1.0',
    label: '1.0',
    parent: '2240',
  },
  {
    key: '309',
    value: '1.5',
    label: '1.5',
    parent: '37',
  },
  {
    key: '374',
    value: '1.3',
    label: '1.3',
    parent: '363',
  },
  {
    key: '375',
    value: '1.5',
    label: '1.5',
    parent: '363',
  },
  {
    key: '376',
    value: '1.6',
    label: '1.6',
    parent: '363',
  },
  {
    key: '2950',
    value: '2.8',
    label: '2.8',
    parent: '2949',
  },
  {
    key: '2175',
    value: '1.0',
    label: '1.0',
    parent: '2110',
  },
  {
    key: '2111',
    value: '1.2',
    label: '1.2',
    parent: '2110',
  },
  {
    key: '65',
    value: '1.3',
    label: '1.3',
    parent: '27',
  },
  {
    key: '377',
    value: '2.8',
    label: '2.8',
    parent: '364',
  },
  {
    key: '378',
    value: '1.5',
    label: '1.5',
    parent: '365',
  },
  {
    key: '380',
    value: '1.6',
    label: '1.6',
    parent: '365',
  },
  {
    key: '348',
    value: '1.5',
    label: '1.5',
    parent: '28',
  },
  {
    key: '330',
    value: '1.0',
    label: '1.0',
    parent: '23',
  },
  {
    key: '43',
    value: '1.3',
    label: '1.3',
    parent: '23',
  },
  {
    key: '381',
    value: '1.3',
    label: '1.3',
    parent: '366',
  },
  {
    key: '2614',
    value: '1.0',
    label: '1.0',
    parent: '367',
  },
  {
    key: '382',
    value: '1.3',
    label: '1.3',
    parent: '367',
  },
  {
    key: '383',
    value: '1.5',
    label: '1.5',
    parent: '367',
  },
  {
    key: '1675',
    value: '1.2',
    label: '1.2',
    parent: '1644',
  },
  {
    key: '1676',
    value: '1.2',
    label: '1.2',
    parent: '1645',
  },
  {
    key: '2079',
    value: '2.4',
    label: '2.4',
    parent: '2078',
  },
  {
    key: '2011',
    value: '1.5',
    label: '1.5',
    parent: '2010',
  },
  {
    key: '774',
    value: '2.0',
    label: '2.0',
    parent: '765',
  },
  {
    key: '776',
    value: '2.3',
    label: '2.3',
    parent: '765',
  },
  {
    key: '775',
    value: '3.0',
    label: '3.0',
    parent: '765',
  },
  {
    key: '781',
    value: '2.0',
    label: '2.0',
    parent: '766',
  },
  {
    key: '777',
    value: '2.5',
    label: '2.5',
    parent: '766',
  },
  {
    key: '778',
    value: '4.6',
    label: '4.6',
    parent: '767',
  },
  {
    key: '779',
    value: '2.5',
    label: '2.5',
    parent: '768',
  },
  {
    key: '1677',
    value: '1.4',
    label: '1.4',
    parent: '1647',
  },
  {
    key: '1678',
    value: '1.5',
    label: '1.5',
    parent: '1647',
  },
  {
    key: '1679',
    value: '1.6',
    label: '1.6',
    parent: '1647',
  },
  {
    key: '780',
    value: '1.8',
    label: '1.8',
    parent: '769',
  },
  {
    key: '1680',
    value: '2.0',
    label: '2.0',
    parent: '769',
  },
  {
    key: '2581',
    value: '1.3',
    label: '1.3',
    parent: '770',
  },
  {
    key: '783',
    value: '1.6',
    label: '1.6',
    parent: '770',
  },
  {
    key: '785',
    value: '1.8',
    label: '1.8',
    parent: '770',
  },
  {
    key: '786',
    value: '1.8',
    label: '1.8',
    parent: '771',
  },
  {
    key: '787',
    value: '2.0',
    label: '2.0',
    parent: '771',
  },
  {
    key: '1302',
    value: '2.2',
    label: '2.2',
    parent: '772',
  },
  {
    key: '788',
    value: '2.5',
    label: '2.5',
    parent: '772',
  },
  {
    key: '789',
    value: '2.9',
    label: '2.9',
    parent: '772',
  },
  {
    key: '790',
    value: '3.0',
    label: '3.0',
    parent: '772',
  },
  {
    key: '2589',
    value: '3.2',
    label: '3.2',
    parent: '772',
  },
  {
    key: '791',
    value: '2.0',
    label: '2.0',
    parent: '773',
  },
  {
    key: '2644',
    value: '6.0',
    label: '6.0',
    parent: '2643',
  },
  {
    key: '2428',
    value: '2.8',
    label: '2.8',
    parent: '2427',
  },
  {
    key: '2639',
    value: '8.5',
    label: '8.5',
    parent: '2638',
  },
  {
    key: '1433',
    value: '3.0',
    label: '3.0',
    parent: '1432',
  },
  {
    key: '1964',
    value: '4.0',
    label: '4.0',
    parent: '1432',
  },
  {
    key: '2879',
    value: '4.0',
    label: '4.0',
    parent: '2878',
  },
  {
    key: '2998',
    value: '7.5',
    label: '7.5',
    parent: '2997',
  },
  {
    key: '2868',
    value: '7.7',
    label: '7.7',
    parent: '2867',
  },
  {
    key: '2672',
    value: '9.5',
    label: '9.5',
    parent: '2671',
  },
  {
    key: '2884',
    value: '7.7',
    label: '7.7',
    parent: '2883',
  },
  {
    key: '2417',
    value: '7.7',
    label: '7.7',
    parent: '2415',
  },
  {
    key: '2115',
    value: '7.7',
    label: '7.7',
    parent: '2114',
  },
  {
    key: '1979',
    value: '7.5',
    label: '7.5',
    parent: '1789',
  },
  {
    key: '1790',
    value: '7.7',
    label: '7.7',
    parent: '1789',
  },
  {
    key: '499',
    value: '2.0',
    label: '2.0',
    parent: '487',
  },
  {
    key: '500',
    value: '2.2',
    label: '2.2',
    parent: '487',
  },
  {
    key: '501',
    value: '2.3',
    label: '2.3',
    parent: '487',
  },
  {
    key: '502',
    value: '2.4',
    label: '2.4',
    parent: '487',
  },
  {
    key: '503',
    value: '3.0',
    label: '3.0',
    parent: '487',
  },
  {
    key: '504',
    value: '3.5',
    label: '3.5',
    parent: '487',
  },
  {
    key: '2001',
    value: '2.3',
    label: '2.3',
    parent: '2000',
  },
  {
    key: '2202',
    value: '2.4',
    label: '2.4',
    parent: '2000',
  },
  {
    key: '40',
    value: '1.2',
    label: '1.2',
    parent: '30',
  },
  {
    key: '486',
    value: '1.3',
    label: '1.3',
    parent: '30',
  },
  {
    key: '3100',
    value: '1.5',
    label: '1.5',
    parent: '30',
  },
  {
    key: '1985',
    value: '1.5',
    label: '1.5',
    parent: '1984',
  },
  {
    key: '505',
    value: '1.3',
    label: '1.3',
    parent: '31',
  },
  {
    key: '506',
    value: '1.5',
    label: '1.5',
    parent: '31',
  },
  {
    key: '2862',
    value: '1.5',
    label: '1.5',
    parent: '488',
  },
  {
    key: '507',
    value: '1.6',
    label: '1.6',
    parent: '488',
  },
  {
    key: '508',
    value: '1.7',
    label: '1.7',
    parent: '488',
  },
  {
    key: '509',
    value: '1.8',
    label: '1.8',
    parent: '488',
  },
  {
    key: '510',
    value: '2.0',
    label: '2.0',
    parent: '488',
  },
  {
    key: '3053',
    value: '1.5',
    label: '1.5',
    parent: '32',
  },
  {
    key: '511',
    value: '2.0',
    label: '2.0',
    parent: '32',
  },
  {
    key: '512',
    value: '2.4',
    label: '2.4',
    parent: '32',
  },
  {
    key: '515',
    value: '1.7',
    label: '1.7',
    parent: '489',
  },
  {
    key: '516',
    value: '2.4',
    label: '2.4',
    parent: '490',
  },
  {
    key: '517',
    value: '3.0',
    label: '3.0',
    parent: '490',
  },
  {
    key: '518',
    value: '1.3',
    label: '1.3',
    parent: '491',
  },
  {
    key: '519',
    value: '1.5',
    label: '1.5',
    parent: '491',
  },
  {
    key: '1313',
    value: '1.5',
    label: '1.5',
    parent: '1312',
  },
  {
    key: '1324',
    value: '1.5',
    label: '1.5',
    parent: '492',
  },
  {
    key: '520',
    value: '1.6',
    label: '1.6',
    parent: '492',
  },
  {
    key: '2237',
    value: '1.8',
    label: '1.8',
    parent: '492',
  },
  {
    key: '521',
    value: '2.0',
    label: '2.0',
    parent: '493',
  },
  {
    key: '41',
    value: '1.5',
    label: '1.5',
    parent: '29',
  },
  {
    key: '522',
    value: '3.5',
    label: '3.5',
    parent: '494',
  },
  {
    key: '1336',
    value: '1.5',
    label: '1.5',
    parent: '1335',
  },
  {
    key: '525',
    value: '2.3',
    label: '2.3',
    parent: '495',
  },
  {
    key: '526',
    value: '2.4',
    label: '2.4',
    parent: '495',
  },
  {
    key: '527',
    value: '3.0',
    label: '3.0',
    parent: '495',
  },
  {
    key: '531',
    value: '2.0',
    label: '2.0',
    parent: '497',
  },
  {
    key: '528',
    value: '1.7',
    label: '1.7',
    parent: '498',
  },
  {
    key: '529',
    value: '2.0',
    label: '2.0',
    parent: '498',
  },
  {
    key: '844',
    value: '1.5',
    label: '1.5',
    parent: '821',
  },
  {
    key: '846',
    value: '1.0',
    label: '1.0',
    parent: '822',
  },
  {
    key: '2580',
    value: '1.1',
    label: '1.1',
    parent: '822',
  },
  {
    key: '2327',
    value: '1.4',
    label: '1.4',
    parent: '823',
  },
  {
    key: '847',
    value: '1.5',
    label: '1.5',
    parent: '823',
  },
  {
    key: '848',
    value: '3.3',
    label: '3.3',
    parent: '824',
  },
  {
    key: '850',
    value: '2.0',
    label: '2.0',
    parent: '826',
  },
  {
    key: '864',
    value: '2.7',
    label: '2.7',
    parent: '826',
  },
  {
    key: '851',
    value: '1.6',
    label: '1.6',
    parent: '827',
  },
  {
    key: '852',
    value: '1.5',
    label: '1.5',
    parent: '828',
  },
  {
    key: '853',
    value: '1.5',
    label: '1.5',
    parent: '829',
  },
  {
    key: '854',
    value: '1.3',
    label: '1.3',
    parent: '832',
  },
  {
    key: '855',
    value: '1.4',
    label: '1.4',
    parent: '832',
  },
  {
    key: '856',
    value: '2.5',
    label: '2.5',
    parent: '831',
  },
  {
    key: '857',
    value: '3.0',
    label: '3.0',
    parent: '833',
  },
  {
    key: '1621',
    value: '2.4',
    label: '2.4',
    parent: '1620',
  },
  {
    key: '3109',
    value: '2.5',
    label: '2.5',
    parent: '1620',
  },
  {
    key: '3078',
    value: '3.9',
    label: '3.9',
    parent: '3077',
  },
  {
    key: '2269',
    value: '4.0',
    label: '4.0',
    parent: '2267',
  },
  {
    key: '2129',
    value: '1.4',
    label: '1.4',
    parent: '1652',
  },
  {
    key: '858',
    value: '1.1',
    label: '1.1',
    parent: '834',
  },
  {
    key: '863',
    value: '2.4',
    label: '2.4',
    parent: '834',
  },
  {
    key: '859',
    value: '1.6',
    label: '1.6',
    parent: '835',
  },
  {
    key: '861',
    value: '3.5',
    label: '3.5',
    parent: '836',
  },
  {
    key: '860',
    value: '3.9',
    label: '3.9',
    parent: '836',
  },
  {
    key: '904',
    value: '2.2',
    label: '2.2',
    parent: '840',
  },
  {
    key: '867',
    value: '2.4',
    label: '2.4',
    parent: '840',
  },
  {
    key: '865',
    value: '2.7',
    label: '2.7',
    parent: '840',
  },
  {
    key: '869',
    value: '2.4',
    label: '2.4',
    parent: '841',
  },
  {
    key: '870',
    value: '2.5',
    label: '2.5',
    parent: '841',
  },
  {
    key: '2443',
    value: '2.5',
    label: '2.5',
    parent: '2442',
  },
  {
    key: '866',
    value: '2.0',
    label: '2.0',
    parent: '839',
  },
  {
    key: '871',
    value: '2.7',
    label: '2.7',
    parent: '839',
  },
  {
    key: '872',
    value: '3.3',
    label: '3.3',
    parent: '843',
  },
  {
    key: '874',
    value: '2.0',
    label: '2.0',
    parent: '842',
  },
  {
    key: '2630',
    value: '5.0',
    label: '5.0',
    parent: '2629',
  },
  {
    key: '2230',
    value: '2.0',
    label: '2.0',
    parent: '2229',
  },
  {
    key: '661',
    value: '2.5',
    label: '2.5',
    parent: '655',
  },
  {
    key: '662',
    value: '9.8',
    label: '9.8',
    parent: '656',
  },
  {
    key: '1484',
    value: '2.5',
    label: '2.5',
    parent: '657',
  },
  {
    key: '663',
    value: '3.0',
    label: '3.0',
    parent: '657',
  },
  {
    key: '664',
    value: '2.5',
    label: '2.5',
    parent: '658',
  },
  {
    key: '670',
    value: '2.3',
    label: '2.3',
    parent: '665',
  },
  {
    key: '671',
    value: '2.5',
    label: '2.5',
    parent: '665',
  },
  {
    key: '682',
    value: '2.7',
    label: '2.7',
    parent: '665',
  },
  {
    key: '666',
    value: '2.8',
    label: '2.8',
    parent: '665',
  },
  {
    key: '667',
    value: '4.3',
    label: '4.3',
    parent: '665',
  },
  {
    key: '668',
    value: '4.5',
    label: '4.5',
    parent: '665',
  },
  {
    key: '2232',
    value: '4.6',
    label: '4.6',
    parent: '665',
  },
  {
    key: '3113',
    value: '5.8',
    label: '5.8',
    parent: '665',
  },
  {
    key: '3111',
    value: '6.1',
    label: '6.1',
    parent: '665',
  },
  {
    key: '2379',
    value: '5.2',
    label: '5.2',
    parent: '2378',
  },
  {
    key: '2382',
    value: '8.3',
    label: '8.3',
    parent: '2381',
  },
  {
    key: '2167',
    value: '2.6',
    label: '2.6',
    parent: '2166',
  },
  {
    key: '2171',
    value: '7.8',
    label: '7.8',
    parent: '2166',
  },
  {
    key: '2192',
    value: '7.8',
    label: '7.8',
    parent: '2190',
  },
  {
    key: '2191',
    value: '7.9',
    label: '7.9',
    parent: '2190',
  },
  {
    key: '2287',
    value: '5.2',
    label: '5.2',
    parent: '704',
  },
  {
    key: '1952',
    value: '8.0',
    label: '8.0',
    parent: '704',
  },
  {
    key: '3032',
    value: '7.2',
    label: '7.2',
    parent: '3031',
  },
  {
    key: '3030',
    value: '7.2',
    label: '7.2',
    parent: '3029',
  },
  {
    key: '1807',
    value: '2.5',
    label: '2.5',
    parent: '1806',
  },
  {
    key: '669',
    value: '2.5',
    label: '2.5',
    parent: '659',
  },
  {
    key: '2104',
    value: '5.2',
    label: '5.2',
    parent: '2103',
  },
  {
    key: '2986',
    value: '2.2',
    label: '2.2',
    parent: '660',
  },
  {
    key: '2100',
    value: '2.3',
    label: '2.3',
    parent: '660',
  },
  {
    key: '1512',
    value: '2.5',
    label: '2.5',
    parent: '660',
  },
  {
    key: '3068',
    value: '2.5',
    label: '2.5',
    parent: '3067',
  },
  {
    key: '2662',
    value: '3.0',
    label: '3.0',
    parent: '2661',
  },
  {
    key: '3104',
    value: '3.8',
    label: '3.8',
    parent: '3103',
  },
  {
    key: '2973',
    value: '3.8',
    label: '3.8',
    parent: '2972',
  },
  {
    key: '1990',
    value: '1.8',
    label: '1.8',
    parent: '1989',
  },
  {
    key: '2251',
    value: '2.5',
    label: '2.5',
    parent: '2250',
  },
  {
    key: '1681',
    value: '1.1',
    label: '1.1',
    parent: '1653',
  },
  {
    key: '1682',
    value: '1.2',
    label: '1.2',
    parent: '1653',
  },
  {
    key: '1683',
    value: '2.7',
    label: '2.7',
    parent: '1655',
  },
  {
    key: '1684',
    value: '1.2',
    label: '1.2',
    parent: '1654',
  },
  {
    key: '1685',
    value: '1.4',
    label: '1.4',
    parent: '1654',
  },
  {
    key: '1686',
    value: '1.5',
    label: '1.5',
    parent: '1654',
  },
  {
    key: '2005',
    value: '1.4',
    label: '1.4',
    parent: '2004',
  },
  {
    key: '2258',
    value: '2.5',
    label: '2.5',
    parent: '2257',
  },
  {
    key: '1687',
    value: '2.0',
    label: '2.0',
    parent: '1656',
  },
  {
    key: '1688',
    value: '2.7',
    label: '2.7',
    parent: '1657',
  },
  {
    key: '2169',
    value: '1.0',
    label: '1.0',
    parent: '2165',
  },
  {
    key: '2484',
    value: '5.2',
    label: '5.2',
    parent: '2483',
  },
  {
    key: '3049',
    value: '3.0',
    label: '3.0',
    parent: '3048',
  },
  {
    key: '2357',
    value: '4.6',
    label: '4.6',
    parent: '2356',
  },
  {
    key: '3045',
    value: '5.6',
    label: '5.6',
    parent: '3044',
  },
  {
    key: '2585',
    value: '3.0',
    label: '3.0',
    parent: '2584',
  },
  {
    key: '3042',
    value: '3.5',
    label: '3.5',
    parent: '3041',
  },
  {
    key: '2492',
    value: '2.7',
    label: '2.7',
    parent: '2491',
  },
  {
    key: '2016',
    value: '-',
    label: '-',
    parent: '2015',
  },
  {
    key: '2020',
    value: '40.400',
    label: '40.400',
    parent: '2015',
  },
  {
    key: '2017',
    value: '-',
    label: '-',
    parent: '2014',
  },
  {
    key: '2021',
    value: '40.480',
    label: '40.480',
    parent: '2014',
  },
  {
    key: '2471',
    value: '40.5',
    label: '40.5',
    parent: '2014',
  },
  {
    key: '1425',
    value: '1.5',
    label: '1.5',
    parent: '1424',
  },
  {
    key: '964',
    value: '1.6',
    label: '1.6',
    parent: '953',
  },
  {
    key: '965',
    value: '2.0',
    label: '2.0',
    parent: '953',
  },
  {
    key: '955',
    value: '1.8',
    label: '1.8',
    parent: '937',
  },
  {
    key: '956',
    value: '2.0',
    label: '2.0',
    parent: '937',
  },
  {
    key: '2400',
    value: '2.0',
    label: '2.0',
    parent: '2399',
  },
  {
    key: '968',
    value: '2.5',
    label: '2.5',
    parent: '949',
  },
  {
    key: '957',
    value: '2.0',
    label: '2.0',
    parent: '938',
  },
  {
    key: '958',
    value: '2.5',
    label: '2.5',
    parent: '938',
  },
  {
    key: '2634',
    value: '2.3',
    label: '2.3',
    parent: '2633',
  },
  {
    key: '959',
    value: '2.5',
    label: '2.5',
    parent: '946',
  },
  {
    key: '1948',
    value: '2.0',
    label: '2.0',
    parent: '1947',
  },
  {
    key: '960',
    value: '2.5',
    label: '2.5',
    parent: '952',
  },
  {
    key: '2042',
    value: '2.0',
    label: '2.0',
    parent: '2041',
  },
  {
    key: '2393',
    value: '2.5',
    label: '2.5',
    parent: '2041',
  },
  {
    key: '961',
    value: '2.3',
    label: '2.3',
    parent: '950',
  },
  {
    key: '962',
    value: '3.7',
    label: '3.7',
    parent: '951',
  },
  {
    key: '963',
    value: '2.0',
    label: '2.0',
    parent: '939',
  },
  {
    key: '966',
    value: '2.5',
    label: '2.5',
    parent: '944',
  },
  {
    key: '967',
    value: '1.3',
    label: '1.3',
    parent: '940',
  },
  {
    key: '991',
    value: '1.4',
    label: '1.4',
    parent: '940',
  },
  {
    key: '970',
    value: '1.8',
    label: '1.8',
    parent: '943',
  },
  {
    key: '972',
    value: '1.3',
    label: '1.3',
    parent: '947',
  },
  {
    key: '973',
    value: '2.0',
    label: '2.0',
    parent: '945',
  },
  {
    key: '969',
    value: '2.3',
    label: '2.3',
    parent: '945',
  },
  {
    key: '974',
    value: '3.0',
    label: '3.0',
    parent: '945',
  },
  {
    key: '975',
    value: '1.4',
    label: '1.4',
    parent: '942',
  },
  {
    key: '2602',
    value: '1.3',
    label: '1.3',
    parent: '2601',
  },
  {
    key: '3027',
    value: '1.4',
    label: '1.4',
    parent: '2601',
  },
  {
    key: '2369',
    value: '4.8',
    label: '4.8',
    parent: '2368',
  },
  {
    key: '1036',
    value: '1.4',
    label: '1.4',
    parent: '993',
  },
  {
    key: '1037',
    value: '1.5',
    label: '1.5',
    parent: '994',
  },
  {
    key: '1038',
    value: '1.6',
    label: '1.6',
    parent: '995',
  },
  {
    key: '1039',
    value: '1.7',
    label: '1.7',
    parent: '996',
  },
  {
    key: '2654',
    value: '1.7',
    label: '1.7',
    parent: '2653',
  },
  {
    key: '1040',
    value: '2.0',
    label: '2.0',
    parent: '997',
  },
  {
    key: '2480',
    value: '1.8',
    label: '1.8',
    parent: '1004',
  },
  {
    key: '1041',
    value: '2.0',
    label: '2.0',
    parent: '1004',
  },
  {
    key: '1042',
    value: '2.3',
    label: '2.3',
    parent: '999',
  },
  {
    key: '2608',
    value: '2.4',
    label: '2.4',
    parent: '1000',
  },
  {
    key: '1043',
    value: '2.6',
    label: '2.6',
    parent: '1000',
  },
  {
    key: '2435',
    value: '1.8',
    label: '1.8',
    parent: '2434',
  },
  {
    key: '1044',
    value: '2.7',
    label: '2.7',
    parent: '1001',
  },
  {
    key: '1045',
    value: '3.0',
    label: '3.0',
    parent: '1002',
  },
  {
    key: '2691',
    value: '3.0',
    label: '3.0',
    parent: '2690',
  },
  {
    key: '1046',
    value: '3.2',
    label: '3.2',
    parent: '1003',
  },
  {
    key: '1047',
    value: '2.3',
    label: '2.3',
    parent: '1006',
  },
  {
    key: '1049',
    value: '2.6',
    label: '2.6',
    parent: '1007',
  },
  {
    key: '1050',
    value: '3.2',
    label: '3.2',
    parent: '1008',
  },
  {
    key: '1051',
    value: '3.5',
    label: '3.5',
    parent: '1010',
  },
  {
    key: '2952',
    value: '1.8',
    label: '1.8',
    parent: '1011',
  },
  {
    key: '1052',
    value: '2.0',
    label: '2.0',
    parent: '1011',
  },
  {
    key: '1053',
    value: '2.2',
    label: '2.2',
    parent: '1012',
  },
  {
    key: '1054',
    value: '2.3',
    label: '2.3',
    parent: '1013',
  },
  {
    key: '1055',
    value: '2.6',
    label: '2.6',
    parent: '1014',
  },
  {
    key: '2975',
    value: '1.8',
    label: '1.8',
    parent: '2646',
  },
  {
    key: '2647',
    value: '2.6',
    label: '2.6',
    parent: '2646',
  },
  {
    key: '1056',
    value: '2.6',
    label: '2.6',
    parent: '1015',
  },
  {
    key: '1057',
    value: '3.0',
    label: '3.0',
    parent: '1016',
  },
  {
    key: '2149',
    value: '3.0',
    label: '3.0',
    parent: '2148',
  },
  {
    key: '1058',
    value: '3.2',
    label: '3.2',
    parent: '1018',
  },
  {
    key: '1062',
    value: '3.2',
    label: '3.2',
    parent: '1022',
  },
  {
    key: '1059',
    value: '3.0',
    label: '3.0',
    parent: '1019',
  },
  {
    key: '1060',
    value: '2.7',
    label: '2.7',
    parent: '1020',
  },
  {
    key: '1061',
    value: '3.2',
    label: '3.2',
    parent: '1021',
  },
  {
    key: '2452',
    value: '4.3',
    label: '4.3',
    parent: '2451',
  },
  {
    key: '1063',
    value: '2.8',
    label: '2.8',
    parent: '1023',
  },
  {
    key: '2696',
    value: '3.0',
    label: '3.0',
    parent: '2695',
  },
  {
    key: '1064',
    value: '3.2',
    label: '3.2',
    parent: '1024',
  },
  {
    key: '1065',
    value: '3.8',
    label: '3.8',
    parent: '1025',
  },
  {
    key: '1066',
    value: '5.0',
    label: '5.0',
    parent: '1026',
  },
  {
    key: '1067',
    value: '5.5',
    label: '5.5',
    parent: '1028',
  },
  {
    key: '1068',
    value: '5.0',
    label: '5.0',
    parent: '1029',
  },
  {
    key: '1069',
    value: '2.0',
    label: '2.0',
    parent: '1030',
  },
  {
    key: '1070',
    value: '2.3',
    label: '2.3',
    parent: '1031',
  },
  {
    key: '1071',
    value: '3.8',
    label: '3.8',
    parent: '1032',
  },
  {
    key: '3022',
    value: '1.0',
    label: '1.0',
    parent: '3021',
  },
  {
    key: '1072',
    value: '1.9',
    label: '1.9',
    parent: '1033',
  },
  {
    key: '1074',
    value: '3.0',
    label: '3.0',
    parent: '1034',
  },
  {
    key: '1073',
    value: '3.2',
    label: '3.2',
    parent: '1034',
  },
  {
    key: '1076',
    value: '2.2',
    label: '2.2',
    parent: '1035',
  },
  {
    key: '1075',
    value: '3.0',
    label: '3.0',
    parent: '1035',
  },
  {
    key: '2291',
    value: '12.0',
    label: '12.0',
    parent: '2290',
  },
  {
    key: '1957',
    value: '12.0',
    label: '12.0',
    parent: '1956',
  },
  {
    key: '1245',
    value: '1.8',
    label: '1.8',
    parent: '1232',
  },
  {
    key: '2943',
    value: '2.5',
    label: '2.5',
    parent: '2942',
  },
  {
    key: '1261',
    value: '11.0',
    label: '11.0',
    parent: '1233',
  },
  {
    key: '1305',
    value: '2.5',
    label: '2.5',
    parent: '1304',
  },
  {
    key: '1959',
    value: '2.5',
    label: '2.5',
    parent: '1233',
  },
  {
    key: '1252',
    value: '3.0',
    label: '3.0',
    parent: '1233',
  },
  {
    key: '2093',
    value: '3.3',
    label: '3.3',
    parent: '1304',
  },
  {
    key: '1253',
    value: '3.3',
    label: '3.3',
    parent: '1233',
  },
  {
    key: '1254',
    value: '3.7',
    label: '3.7',
    parent: '1233',
  },
  {
    key: '1255',
    value: '3.9',
    label: '3.9',
    parent: '1233',
  },
  {
    key: '1258',
    value: '4.0',
    label: '4.0',
    parent: '1233',
  },
  {
    key: '1435',
    value: '4.0',
    label: '4.0',
    parent: '1304',
  },
  {
    key: '1256',
    value: '4.7',
    label: '4.7',
    parent: '1233',
  },
  {
    key: '1257',
    value: '4.9',
    label: '4.9',
    parent: '1233',
  },
  {
    key: '1246',
    value: '1.3',
    label: '1.3',
    parent: '1234',
  },
  {
    key: '1247',
    value: '1.5',
    label: '1.5',
    parent: '1234',
  },
  {
    key: '2978',
    value: '2.0',
    label: '2.0',
    parent: '2977',
  },
  {
    key: '2264',
    value: '7.5',
    label: '7.5',
    parent: '2263',
  },
  {
    key: '2298',
    value: '11.9',
    label: '11.9',
    parent: '2297',
  },
  {
    key: '1954',
    value: '12.0',
    label: '12.0',
    parent: '1945',
  },
  {
    key: '2351',
    value: '13.5',
    label: '13.5',
    parent: '2350',
  },
  {
    key: '2069',
    value: '11.0',
    label: '11.0',
    parent: '1235',
  },
  {
    key: '2070',
    value: '11.14',
    label: '11.14',
    parent: '1235',
  },
  {
    key: '2419',
    value: '12',
    label: '12',
    parent: '1235',
  },
  {
    key: '2032',
    value: '12.0',
    label: '12.0',
    parent: '1235',
  },
  {
    key: '2460',
    value: '16.0',
    label: '16.0',
    parent: '1235',
  },
  {
    key: '1262',
    value: '17.7',
    label: '17.7',
    parent: '1235',
  },
  {
    key: '2422',
    value: '17.8',
    label: '17.8',
    parent: '1235',
  },
  {
    key: '2676',
    value: '3.9',
    label: '3.9',
    parent: '1235',
  },
  {
    key: '2158',
    value: '6.4',
    label: '6.4',
    parent: '1235',
  },
  {
    key: '1259',
    value: '7.5',
    label: '7.5',
    parent: '1235',
  },
  {
    key: '3036',
    value: '7.5',
    label: '7.5',
    parent: '3035',
  },
  {
    key: '3038',
    value: '8.2',
    label: '8.2',
    parent: '3035',
  },
  {
    key: '2599',
    value: '16.0',
    label: '16.0',
    parent: '2598',
  },
  {
    key: '2348',
    value: '11',
    label: '11',
    parent: '2347',
  },
  {
    key: '1263',
    value: '2.0',
    label: '2.0',
    parent: '1236',
  },
  {
    key: '2025',
    value: '2.5',
    label: '2.5',
    parent: '1236',
  },
  {
    key: '1264',
    value: '2.4',
    label: '2.4',
    parent: '1237',
  },
  {
    key: '1265',
    value: '1.6',
    label: '1.6',
    parent: '1238',
  },
  {
    key: '1284',
    value: '2.0',
    label: '2.0',
    parent: '1238',
  },
  {
    key: '1266',
    value: '2.5',
    label: '2.5',
    parent: '1238',
  },
  {
    key: '1267',
    value: '1.5',
    label: '1.5',
    parent: '1239',
  },
  {
    key: '1268',
    value: '1.6',
    label: '1.6',
    parent: '1239',
  },
  {
    key: '1269',
    value: '1.8',
    label: '1.8',
    parent: '1239',
  },
  {
    key: '2939',
    value: '2.0',
    label: '2.0',
    parent: '2938',
  },
  {
    key: '3060',
    value: '1.5',
    label: '1.5',
    parent: '1240',
  },
  {
    key: '1282',
    value: '1.2',
    label: '1.2',
    parent: '1281',
  },
  {
    key: '1941',
    value: '2.0',
    label: '2.0',
    parent: '1940',
  },
  {
    key: '3071',
    value: '2.4',
    label: '2.4',
    parent: '1243',
  },
  {
    key: '1555',
    value: '2.5',
    label: '2.5',
    parent: '1243',
  },
  {
    key: '2301',
    value: '2.8',
    label: '2.8',
    parent: '1243',
  },
  {
    key: '2360',
    value: '3.0',
    label: '3.0',
    parent: '1243',
  },
  {
    key: '1556',
    value: '3.5',
    label: '3.5',
    parent: '1243',
  },
  {
    key: '1427',
    value: '2.5',
    label: '2.5',
    parent: '1244',
  },
  {
    key: '1300',
    value: '2.8',
    label: '2.8',
    parent: '1244',
  },
  {
    key: '2134',
    value: '2.5',
    label: '2.5',
    parent: '2133',
  },
  {
    key: '2135',
    value: '2.8',
    label: '2.8',
    parent: '2133',
  },
  {
    key: '3096',
    value: '1.5',
    label: '1.5',
    parent: '3095',
  },
  {
    key: '1689',
    value: '1.6',
    label: '1.6',
    parent: '1658',
  },
  {
    key: '2464',
    value: '14.3',
    label: '14.3',
    parent: '2463',
  },
  {
    key: '594',
    value: '6.9',
    label: '6.9',
    parent: '572',
  },
  {
    key: '1585',
    value: '7.0',
    label: '7.0',
    parent: '572',
  },
  {
    key: '2277',
    value: '9.0',
    label: '9.0',
    parent: '572',
  },
  {
    key: '2683',
    value: '12.0',
    label: '12.0',
    parent: '2682',
  },
  {
    key: '2270',
    value: '9.0',
    label: '9.0',
    parent: '2268',
  },
  {
    key: '1938',
    value: '2.5',
    label: '2.5',
    parent: '1937',
  },
  {
    key: '1291',
    value: '1.5',
    label: '1.5',
    parent: '1290',
  },
  {
    key: '595',
    value: '3.5',
    label: '3.5',
    parent: '573',
  },
  {
    key: '598',
    value: '2.5',
    label: '2.5',
    parent: '596',
  },
  {
    key: '597',
    value: '3.0',
    label: '3.0',
    parent: '596',
  },
  {
    key: '600',
    value: '1.6',
    label: '1.6',
    parent: '599',
  },
  {
    key: '601',
    value: '1.5',
    label: '1.5',
    parent: '34',
  },
  {
    key: '602',
    value: '1.8',
    label: '1.8',
    parent: '34',
  },
  {
    key: '593',
    value: '3.0',
    label: '3.0',
    parent: '34',
  },
  {
    key: '2456',
    value: '4.0',
    label: '4.0',
    parent: '2455',
  },
  {
    key: '603',
    value: '3.0',
    label: '3.0',
    parent: '576',
  },
  {
    key: '1590',
    value: '1.5',
    label: '1.5',
    parent: '33',
  },
  {
    key: '604',
    value: '1.8',
    label: '1.8',
    parent: '577',
  },
  {
    key: '605',
    value: '1.5',
    label: '1.5',
    parent: '578',
  },
  {
    key: '38',
    value: '1.2',
    label: '1.2',
    parent: '35',
  },
  {
    key: '606',
    value: '1.4',
    label: '1.4',
    parent: '35',
  },
  {
    key: '39',
    value: '1.5',
    label: '1.5',
    parent: '35',
  },
  {
    key: '608',
    value: '2.5',
    label: '2.5',
    parent: '579',
  },
  {
    key: '611',
    value: '1.8',
    label: '1.8',
    parent: '582',
  },
  {
    key: '612',
    value: '2.0',
    label: '2.0',
    parent: '582',
  },
  {
    key: '613',
    value: '2.4',
    label: '2.4',
    parent: '582',
  },
  {
    key: '614',
    value: '3.3',
    label: '3.3',
    parent: '582',
  },
  {
    key: '615',
    value: '3.0',
    label: '3.0',
    parent: '583',
  },
  {
    key: '617',
    value: '4.2',
    label: '4.2',
    parent: '583',
  },
  {
    key: '618',
    value: '4.8',
    label: '4.8',
    parent: '583',
  },
  {
    key: '619',
    value: '6.9',
    label: '6.9',
    parent: '584',
  },
  {
    key: '2053',
    value: '7.0',
    label: '7.0',
    parent: '2052',
  },
  {
    key: '620',
    value: '6.9',
    label: '6.9',
    parent: '586',
  },
  {
    key: '621',
    value: '1.6',
    label: '1.6',
    parent: '587',
  },
  {
    key: '609',
    value: '1.8',
    label: '1.8',
    parent: '587',
  },
  {
    key: '622',
    value: '1.6',
    label: '1.6',
    parent: '588',
  },
  {
    key: '623',
    value: '2.0',
    label: '2.0',
    parent: '588',
  },
  {
    key: '625',
    value: '2.3',
    label: '2.3',
    parent: '589',
  },
  {
    key: '1594',
    value: '2.5',
    label: '2.5',
    parent: '589',
  },
  {
    key: '626',
    value: '2.4',
    label: '2.4',
    parent: '590',
  },
  {
    key: '627',
    value: '1.5',
    label: '1.5',
    parent: '591',
  },
  {
    key: '2211',
    value: '7.0',
    label: '7.0',
    parent: '2210',
  },
  {
    key: '628',
    value: '2.0',
    label: '2.0',
    parent: '581',
  },
  {
    key: '629',
    value: '2.5',
    label: '2.5',
    parent: '581',
  },
  {
    key: '643',
    value: '2.0',
    label: '2.0',
    parent: '592',
  },
  {
    key: '630',
    value: '3.5',
    label: '3.5',
    parent: '592',
  },
  {
    key: '2075',
    value: '2.5',
    label: '2.5',
    parent: '2074',
  },
  {
    key: '2618',
    value: '1.4',
    label: '1.4',
    parent: '2617',
  },
  {
    key: '2934',
    value: '1.6',
    label: '1.6',
    parent: '2933',
  },
  {
    key: '2029',
    value: '1.8',
    label: '1.8',
    parent: '2027',
  },
  {
    key: '2088',
    value: '1.6',
    label: '1.6',
    parent: '2087',
  },
  {
    key: '2097',
    value: '2.0',
    label: '2.0',
    parent: '2087',
  },
  {
    key: '2261',
    value: '2.0',
    label: '2.0',
    parent: '2260',
  },
  {
    key: '3019',
    value: '2.0',
    label: '2.0',
    parent: '3018',
  },
  {
    key: '2668',
    value: '2.0',
    label: '2.0',
    parent: '2667',
  },
  {
    key: '2468',
    value: '2.0',
    label: '2.0',
    parent: '2467',
  },
  {
    key: '1690',
    value: '1.6',
    label: '1.6',
    parent: '1659',
  },
  {
    key: '1691',
    value: '1.6',
    label: '1.6',
    parent: '1660',
  },
  {
    key: '1692',
    value: '1.3',
    label: '1.3',
    parent: '1661',
  },
  {
    key: '3082',
    value: '1.6',
    label: '1.6',
    parent: '3081',
  },
  {
    key: '1693',
    value: '1.2',
    label: '1.2',
    parent: '1662',
  },
  {
    key: '2195',
    value: '13.0',
    label: '13.0',
    parent: '2194',
  },
  {
    key: '2198',
    value: '11.0',
    label: '11.0',
    parent: '2197',
  },
  {
    key: '2275',
    value: '10.6',
    label: '10.6',
    parent: '2274',
  },
  {
    key: '3007',
    value: '12.0',
    label: '12.0',
    parent: '2274',
  },
  {
    key: '2281',
    value: '13.0',
    label: '13.0',
    parent: '2274',
  },
  {
    key: '2279',
    value: '7.0',
    label: '7.0',
    parent: '2274',
  },
  {
    key: '2280',
    value: '9.0',
    label: '9.0',
    parent: '2274',
  },
  {
    key: '2575',
    value: '13.0',
    label: '13.0',
    parent: '2574',
  },
  {
    key: '1694',
    value: '2.0',
    label: '2.0',
    parent: '1663',
  },
  {
    key: '2143',
    value: '2.0',
    label: '2.0',
    parent: '2142',
  },
  {
    key: '2178',
    value: '2.0',
    label: '2.0',
    parent: '2177',
  },
  {
    key: '1148',
    value: '1.5',
    label: '1.5',
    parent: '1122',
  },
  {
    key: '1149',
    value: '1.5',
    label: '1.5',
    parent: '1120',
  },
  {
    key: '1150',
    value: '1.5',
    label: '1.5',
    parent: '1135',
  },
  {
    key: '3090',
    value: '1.4',
    label: '1.4',
    parent: '1124',
  },
  {
    key: '1151',
    value: '1.5',
    label: '1.5',
    parent: '1124',
  },
  {
    key: '1152',
    value: '1.6',
    label: '1.6',
    parent: '1124',
  },
  {
    key: '1153',
    value: '1.0',
    label: '1.0',
    parent: '1134',
  },
  {
    key: '1154',
    value: '1.0',
    label: '1.0',
    parent: '1133',
  },
  {
    key: '1155',
    value: '1.3',
    label: '1.3',
    parent: '1133',
  },
  {
    key: '1156',
    value: '1.5',
    label: '1.5',
    parent: '1133',
  },
  {
    key: '1157',
    value: '1.6',
    label: '1.6',
    parent: '1133',
  },
  {
    key: '2994',
    value: '1.0',
    label: '1.0',
    parent: '2993',
  },
  {
    key: '1611',
    value: '1.3',
    label: '1.3',
    parent: '1142',
  },
  {
    key: '1207',
    value: '1.4',
    label: '1.4',
    parent: '1142',
  },
  {
    key: '1158',
    value: '1.6',
    label: '1.6',
    parent: '1129',
  },
  {
    key: '1159',
    value: '2.0',
    label: '2.0',
    parent: '1129',
  },
  {
    key: '2125',
    value: '2.5',
    label: '2.5',
    parent: '1129',
  },
  {
    key: '1160',
    value: '1.3',
    label: '1.3',
    parent: '1123',
  },
  {
    key: '1161',
    value: '1.6',
    label: '1.6',
    parent: '1123',
  },
  {
    key: '1162',
    value: '1.3',
    label: '1.3',
    parent: '1137',
  },
  {
    key: '2085',
    value: '1.3',
    label: '1.3',
    parent: '2084',
  },
  {
    key: '1993',
    value: '1.5',
    label: '1.5',
    parent: '1992',
  },
  {
    key: '1173',
    value: '1.5',
    label: '1.5',
    parent: '1136',
  },
  {
    key: '1164',
    value: '2.5',
    label: '2.5',
    parent: '1131',
  },
  {
    key: '1165',
    value: '2.0',
    label: '2.0',
    parent: '1132',
  },
  {
    key: '1166',
    value: '2.4',
    label: '2.4',
    parent: '1132',
  },
  {
    key: '2969',
    value: '1.2',
    label: '1.2',
    parent: '2968',
  },
  {
    key: '1167',
    value: '1.3',
    label: '1.3',
    parent: '1138',
  },
  {
    key: '1168',
    value: '1.0',
    label: '1.0',
    parent: '1146',
  },
  {
    key: '1169',
    value: '1.1',
    label: '1.1',
    parent: '1141',
  },
  {
    key: '2050',
    value: '1.0',
    label: '1.0',
    parent: '2049',
  },
  {
    key: '1170',
    value: '1.0',
    label: '1.0',
    parent: '1126',
  },
  {
    key: '1172',
    value: '1.5',
    label: '1.5',
    parent: '1125',
  },
  {
    key: '1174',
    value: '1.6',
    label: '1.6',
    parent: '1130',
  },
  {
    key: '1272',
    value: '1.2',
    label: '1.2',
    parent: '1271',
  },
  {
    key: '2591',
    value: '1.4',
    label: '1.4',
    parent: '1139',
  },
  {
    key: '1175',
    value: '1.5',
    label: '1.5',
    parent: '1139',
  },
  {
    key: '1287',
    value: '1.5',
    label: '1.5',
    parent: '1140',
  },
  {
    key: '1177',
    value: '1.6',
    label: '1.6',
    parent: '1128',
  },
  {
    key: '2931',
    value: '1.5',
    label: '1.5',
    parent: '2930',
  },
  {
    key: '3087',
    value: '1.4',
    label: '1.4',
    parent: '3086',
  },
  {
    key: '2284',
    value: '1.4',
    label: '1.4',
    parent: '2283',
  },
  {
    key: '1812',
    value: '1.5',
    label: '1.5',
    parent: '1811',
  },
  {
    key: '8',
    value: '1.0',
    label: '1.0',
    parent: '6',
  },
  {
    key: '2612',
    value: '1.2',
    label: '1.2',
    parent: '6',
  },
  {
    key: '64',
    value: '2.4',
    label: '2.4',
    parent: '61',
  },
  {
    key: '1796',
    value: '2.5',
    label: '2.5',
    parent: '61',
  },
  {
    key: '63',
    value: '3.0',
    label: '3.0',
    parent: '61',
  },
  {
    key: '62',
    value: '3.5',
    label: '3.5',
    parent: '61',
  },
  {
    key: '132',
    value: '1.8',
    label: '1.8',
    parent: '131',
  },
  {
    key: '133',
    value: '2.0',
    label: '2.0',
    parent: '131',
  },
  {
    key: '25',
    value: '1.3',
    label: '1.3',
    parent: '7',
  },
  {
    key: '26',
    value: '1.5',
    label: '1.5',
    parent: '7',
  },
  {
    key: '2186',
    value: '1.2',
    label: '1.2',
    parent: '2185',
  },
  {
    key: '3016',
    value: '2.2',
    label: '2.2',
    parent: '110',
  },
  {
    key: '2698',
    value: '2.3',
    label: '2.3',
    parent: '110',
  },
  {
    key: '111',
    value: '2.4',
    label: '2.4',
    parent: '110',
  },
  {
    key: '1361',
    value: '2.5',
    label: '2.5',
    parent: '110',
  },
  {
    key: '1868',
    value: '3.0',
    label: '3.0',
    parent: '110',
  },
  {
    key: '112',
    value: '3.5',
    label: '3.5',
    parent: '110',
  },
  {
    key: '234',
    value: '1.8',
    label: '1.8',
    parent: '232',
  },
  {
    key: '233',
    value: '2.0',
    label: '2.0',
    parent: '232',
  },
  {
    key: '140',
    value: '1.6',
    label: '1.6',
    parent: '119',
  },
  {
    key: '141',
    value: '1.8',
    label: '1.8',
    parent: '119',
  },
  {
    key: '148',
    value: '1.6',
    label: '1.6',
    parent: '147',
  },
  {
    key: '150',
    value: '2.0',
    label: '2.0',
    parent: '147',
  },
  {
    key: '155',
    value: '2.0',
    label: '2.0',
    parent: '154',
  },
  {
    key: '156',
    value: '3.0',
    label: '3.0',
    parent: '154',
  },
  {
    key: '286',
    value: '4.0',
    label: '4.0',
    parent: '284',
  },
  {
    key: '291',
    value: '3.6',
    label: '3.6',
    parent: '285',
  },
  {
    key: '298',
    value: '4.0',
    label: '4.0',
    parent: '285',
  },
  {
    key: '247',
    value: '1.3',
    label: '1.3',
    parent: '246',
  },
  {
    key: '282',
    value: '0.3',
    label: '0.3',
    parent: '273',
  },
  {
    key: '121',
    value: '1.2',
    label: '1.2',
    parent: '120',
  },
  {
    key: '2458',
    value: '1.5',
    label: '1.5',
    parent: '120',
  },
  {
    key: '2304',
    value: '2.4',
    label: '2.4',
    parent: '21',
  },
  {
    key: '81',
    value: '2.5',
    label: '2.5',
    parent: '21',
  },
  {
    key: '78',
    value: '2.7',
    label: '2.7',
    parent: '21',
  },
  {
    key: '3051',
    value: '2.0',
    label: '2.0',
    parent: '237',
  },
  {
    key: '238',
    value: '2.4',
    label: '2.4',
    parent: '237',
  },
  {
    key: '239',
    value: '3.0',
    label: '3.0',
    parent: '237',
  },
  {
    key: '2923',
    value: '3.5',
    label: '3.5',
    parent: '237',
  },
  {
    key: '2445',
    value: '2.5',
    label: '2.5',
    parent: '1392',
  },
  {
    key: '1393',
    value: '2.7',
    label: '2.7',
    parent: '1392',
  },
  {
    key: '1394',
    value: '3.0',
    label: '3.0',
    parent: '1392',
  },
  {
    key: '264',
    value: '2.0',
    label: '2.0',
    parent: '259',
  },
  {
    key: '260',
    value: '2.4',
    label: '2.4',
    parent: '259',
  },
  {
    key: '261',
    value: '2.5',
    label: '2.5',
    parent: '259',
  },
  {
    key: '263',
    value: '3.0',
    label: '3.0',
    parent: '259',
  },
  {
    key: '280',
    value: '2.0',
    label: '2.0',
    parent: '272',
  },
  {
    key: '279',
    value: '2.4',
    label: '2.4',
    parent: '272',
  },
  {
    key: '2322',
    value: '1.8',
    label: '1.8',
    parent: '2321',
  },
  {
    key: '277',
    value: '1.3',
    label: '1.3',
    parent: '271',
  },
  {
    key: '278',
    value: '1.5',
    label: '1.5',
    parent: '271',
  },
  {
    key: '194',
    value: '1.5',
    label: '1.5',
    parent: '193',
  },
  {
    key: '195',
    value: '1.8',
    label: '1.8',
    parent: '193',
  },
  {
    key: '196',
    value: '2.0',
    label: '2.0',
    parent: '193',
  },
  {
    key: '197',
    value: '2.4',
    label: '2.4',
    parent: '193',
  },
  {
    key: '2406',
    value: '2.5',
    label: '2.5',
    parent: '193',
  },
  {
    key: '2408',
    value: '2.6',
    label: '2.6',
    parent: '193',
  },
  {
    key: '90',
    value: '2.0',
    label: '2.0',
    parent: '22',
  },
  {
    key: '2234',
    value: '2.4',
    label: '2.4',
    parent: '22',
  },
  {
    key: '91',
    value: '2.5',
    label: '2.5',
    parent: '22',
  },
  {
    key: '92',
    value: '2.7',
    label: '2.7',
    parent: '22',
  },
  {
    key: '2244',
    value: '2.8',
    label: '2.8',
    parent: '22',
  },
  {
    key: '1455',
    value: '1.5',
    label: '1.5',
    parent: '1454',
  },
  {
    key: '1456',
    value: '1.8',
    label: '1.8',
    parent: '1454',
  },
  {
    key: '2991',
    value: '2.7',
    label: '2.7',
    parent: '183',
  },
  {
    key: '184',
    value: '3.0',
    label: '3.0',
    parent: '183',
  },
  {
    key: '185',
    value: '4.2',
    label: '4.2',
    parent: '183',
  },
  {
    key: '186',
    value: '4.7',
    label: '4.7',
    parent: '183',
  },
  {
    key: '1618',
    value: '3.5',
    label: '3.5',
    parent: '248',
  },
  {
    key: '250',
    value: '4.3',
    label: '4.3',
    parent: '248',
  },
  {
    key: '249',
    value: '4.7',
    label: '4.7',
    parent: '248',
  },
  {
    key: '281',
    value: '5.7',
    label: '5.7',
    parent: '248',
  },
  {
    key: '181',
    value: '1.5',
    label: '1.5',
    parent: '180',
  },
  {
    key: '3002',
    value: '2.5',
    label: '2.5',
    parent: '3001',
  },
  {
    key: '1414',
    value: '2.0',
    label: '2.0',
    parent: '1413',
  },
  {
    key: '274',
    value: '2.7',
    label: '2.7',
    parent: '270',
  },
  {
    key: '275',
    value: '3.0',
    label: '3.0',
    parent: '270',
  },
  {
    key: '276',
    value: '3.4',
    label: '3.4',
    parent: '270',
  },
  {
    key: '2448',
    value: '2.4',
    label: '2.4',
    parent: '225',
  },
  {
    key: '224',
    value: '1.5',
    label: '1.5',
    parent: '223',
  },
  {
    key: '218',
    value: '1.8',
    label: '1.8',
    parent: '215',
  },
  {
    key: '217',
    value: '2.0',
    label: '2.0',
    parent: '215',
  },
  {
    key: '102',
    value: '1.5',
    label: '1.5',
    parent: '59',
  },
  {
    key: '2163',
    value: '1.5',
    label: '1.5',
    parent: '2162',
  },
  {
    key: '177',
    value: '1.5',
    label: '1.5',
    parent: '176',
  },
  {
    key: '165',
    value: '1.0',
    label: '1.0',
    parent: '163',
  },
  {
    key: '166',
    value: '1.3',
    label: '1.3',
    parent: '163',
  },
  {
    key: '1420',
    value: '2.4',
    label: '2.4',
    parent: '1419',
  },
  {
    key: '1798',
    value: '2.5',
    label: '2.5',
    parent: '1419',
  },
  {
    key: '1355',
    value: '1.3',
    label: '1.3',
    parent: '1354',
  },
  {
    key: '1356',
    value: '1.5',
    label: '1.5',
    parent: '1354',
  },
  {
    key: '126',
    value: '1.5',
    label: '1.5',
    parent: '125',
  },
  {
    key: '256',
    value: '1.3',
    label: '1.3',
    parent: '254',
  },
  {
    key: '255',
    value: '1.8',
    label: '1.8',
    parent: '253',
  },
  {
    key: '105',
    value: '1.5',
    label: '1.5',
    parent: '20',
  },
  {
    key: '2248',
    value: '6.9',
    label: '6.9',
    parent: '2247',
  },
  {
    key: '3065',
    value: '1.4',
    label: '1.4',
    parent: '2649',
  },
  {
    key: '2650',
    value: '2.0',
    label: '2.0',
    parent: '2649',
  },
  {
    key: '1997',
    value: '1.4',
    label: '1.4',
    parent: '1996',
  },
  {
    key: '2656',
    value: '3.0',
    label: '3.0',
    parent: '2652',
  },
  {
    key: '2208',
    value: '2.4',
    label: '2.4',
    parent: '2207',
  },
  {
    key: '3024',
    value: '2.9',
    label: '2.9',
    parent: '2207',
  },
]

export default LIST_CYLINDER_VEHICLE